import { createContext } from 'react';
import type { DashboardContextType } from '@/types/application/common/context/portal-context-model';

export const DashboardContext = createContext<DashboardContextType | undefined>(undefined);
